import _ from 'lodash';
import React from 'react';

import { BODY_STYLES } from '@/constants/body-styles';
import { convertToCurrencyFormat } from '@/utils/convert-to-currency-format';
import { priceRangeSliderMarks } from '@/components/discovery-questions-input/utils/price-range-slider-marks';

import CheckboxPanel, { VirtualRefinementList } from './checkbox-panel';
import { yearSliderMarks, POWER_TYPE_MAPPING, ALL_ID } from './constants';
import SliderPanel, { VirtualRange } from './slider-panel';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'filterId' implicitly has an 'any' type.
const buildCheckboxObjects = (filterId, checkboxConfig) =>
  _.map(checkboxConfig, ({ label, id, imageUrl }) => ({
    label,
    id,
    imageUrl,
    filterId,
    checked: false,
  }));

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'checkboxId' implicitly has an 'any' type.
const setCheckboxStateForFilter = (checkboxId, newState, stateActions = {}) => {
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'add' does not exist on type '{}'.
  const { add, remove, update } = stateActions;

  if (checkboxId === ALL_ID && newState) {
    update([]);
  } else if (newState) {
    add(checkboxId);
  } else {
    remove(checkboxId);
  }
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'checkboxObjects' implicitly has an 'any' type.
const sortCheckboxConfigAlphabetically = (checkboxObjects) => {
  const allObject = _.find(checkboxObjects, (checkboxObject) => checkboxObject.id === ALL_ID);
  const sortedCheckboxConfig = _.sortBy(checkboxObjects, ({ label }) => label);
  if (allObject) {
    _.pull(sortedCheckboxConfig, allObject);
    return _.concat(allObject, sortedCheckboxConfig);
  }
  return sortedCheckboxConfig;
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'array' implicitly has an 'any' type.
const reduceArrayToCheckboxObject = (array) => {
  if (_.isEmpty(array)) {
    return { [ALL_ID]: true };
  }
  return _.reduce(array, (total, value) => ({ ...total, [value]: true }), {});
};

const buildFiltersDefaultState = (filterState = {}) => ({
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Property 'selectedPriceRange' does not exist on type '{}'.
  PRICE: filterState.selectedPriceRange || [_.first(priceRangeSliderMarks).value, _.last(priceRangeSliderMarks).value],
});

const algoliaAttributes = {
  MAKE: 'makeId',
  BODY_STYLE: 'derivedBodyStyle',
  YEAR: 'year',
  STAR_RATING: 'starsString',
  SAFETY_FEATURES: 'standardTacFeatureCodes',
  POWER_TYPE: 'powerPlantType',
  LIFESTYLE: 'lifestyle',
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'checkboxConfig' implicitly has an 'any' type.
const buildFilterConfig = (checkboxConfig, filterActions, filterState) => {
  const {
    addBodyStyle,
    addLifestyle,
    addMake,
    addSafetyFeature,
    addStarRating,
    addPowerType,
    removeBodyStyle,
    removeLifestyle,
    removeMake,
    removeSafetyFeature,
    removeStarRating,
    removePowerType,
    resetSelectedYearRange,
    updateLifestyles,
    updateMakes,
    updateSafetyFeatures,
    updateSelectedBodyStyles,
    updateSelectedPriceRange,
    updateUiSelectedPriceRange,
    updateSelectedYearRange,
    updateUiSelectedYearRange,
    updateStarRatings,
    updatePowerTypes,
  } = filterActions;
  const {
    selectedBodyStyles,
    uiSelectedPriceRange,
    selectedSafetyFeatures,
    selectedLifestyles,
    selectedMakes,
    selectedStarRatings,
    selectedYearRange,
    selectedPowerTypes,
    uiSelectedYearRange,
  } = filterState;

  return {
    PRICE: {
      id: 'PRICE',
      name: 'Price',
      content: (isMounted = true) =>
        isMounted && (
          <SliderPanel
            {...{
              allMarks: priceRangeSliderMarks,
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'value' implicitly has an 'any' type.
              getAriaValueText: (value) => `Price ${value}`,
              name: 'budget',
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'value' implicitly has an 'any' type.
              formatter: (value) => {
                // @ts-expect-error [🤖 PLEASE FIX 🤖]: Object is possibly 'undefined'.
                const suffix = value === _.last(priceRangeSliderMarks).value ? '+' : '';
                return `$${convertToCurrencyFormat(value)}${suffix}`;
              },
              attribute: '',
              updateSelectedRange: updateSelectedPriceRange,
              uiSelectedRange: uiSelectedPriceRange,
              updateUiSelectedRange: updateUiSelectedPriceRange,
            }}
          />
        ),
    },
    MAKE: {
      id: 'MAKE',
      name: 'Make',
      content: (isMounted = true) =>
        !isMounted ? (
          <VirtualRefinementList
            {...{
              attribute: algoliaAttributes.MAKE,
              defaultRefinement: selectedMakes,
            }}
          />
        ) : (
          <CheckboxPanel
            {...{
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'checkboxId' implicitly has an 'any' type.
              setter: (checkboxId, value) =>
                setCheckboxStateForFilter(checkboxId, value, {
                  add: addMake,
                  remove: removeMake,
                  update: updateMakes,
                }),
              checkboxes: buildCheckboxObjects('MAKE', sortCheckboxConfigAlphabetically(checkboxConfig.MAKE)),
              attribute: algoliaAttributes.MAKE,
              defaultRefinement: selectedMakes,
            }}
          />
        ),
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'id' implicitly has an 'any' type.
      onRemove: (id) => removeMake(id),
    },
    BODY_STYLE: {
      id: 'BODY_STYLE',
      name: 'Body type',
      content: (isMounted = true) =>
        !isMounted ? (
          <VirtualRefinementList
            {...{
              attribute: algoliaAttributes.BODY_STYLE,
              defaultRefinement: selectedBodyStyles,
            }}
          />
        ) : (
          <CheckboxPanel
            {...{
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'checkboxId' implicitly has an 'any' type.
              setter: (checkboxId, value) =>
                setCheckboxStateForFilter(checkboxId, value, {
                  add: addBodyStyle,
                  remove: removeBodyStyle,
                  update: updateSelectedBodyStyles,
                }),
              checkboxes: buildCheckboxObjects('BODY_STYLE', checkboxConfig.BODY_STYLE),
              attribute: algoliaAttributes.BODY_STYLE,
              defaultRefinement: selectedBodyStyles,
            }}
          />
        ),
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'id' implicitly has an 'any' type.
      onRemove: (id) => removeBodyStyle(id),
    },
    YEAR: {
      id: 'YEAR',
      name: 'Year',
      content: (isMounted = true) =>
        !isMounted ? (
          <VirtualRange
            {...{
              attribute: algoliaAttributes.YEAR,
              defaultRefinement: {
                min: selectedYearRange[0],
                max: selectedYearRange[1],
              },
            }}
          />
        ) : (
          <SliderPanel
            {...{
              allMarks: yearSliderMarks,
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'value' implicitly has an 'any' type.
              getAriaValueText: (value) => `YEAR ${value}`,
              name: 'year',
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'value' implicitly has an 'any' type.
              formatter: (value) => value,
              attribute: algoliaAttributes.YEAR,
              updateSelectedRange: updateSelectedYearRange,
              uiSelectedRange: uiSelectedYearRange,
              updateUiSelectedRange: updateUiSelectedYearRange,
              defaultRefinement: {
                min: selectedYearRange[0],
                max: selectedYearRange[1],
              },
            }}
          />
        ),

      onRemove: () => resetSelectedYearRange(),
    },
    STAR_RATING: {
      id: 'STAR_RATING',
      name: 'Star rating',
      content: (isMounted = true) =>
        !isMounted ? (
          <VirtualRefinementList
            {...{
              attribute: algoliaAttributes.STAR_RATING,
              defaultRefinement: selectedStarRatings,
            }}
          />
        ) : (
          <CheckboxPanel
            {...{
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'checkboxId' implicitly has an 'any' type.
              setter: (checkboxId, value) =>
                setCheckboxStateForFilter(checkboxId, value, {
                  add: addStarRating,
                  remove: removeStarRating,
                  update: updateStarRatings,
                }),
              checkboxes: buildCheckboxObjects('STAR_RATING', checkboxConfig.STAR_RATING),
              columnsPerGridItem: 2,
              attribute: algoliaAttributes.STAR_RATING,
              defaultRefinement: selectedStarRatings,
            }}
          />
        ),
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'id' implicitly has an 'any' type.
      onRemove: (id) => removeStarRating(id),
    },
    SAFETY_FEATURES: {
      id: 'SAFETY_FEATURES',
      name: 'Safety features',
      content: (isMounted = true) =>
        !isMounted ? (
          <VirtualRefinementList
            {...{
              attribute: algoliaAttributes.SAFETY_FEATURES,
              defaultRefinement: selectedSafetyFeatures,
              operator: 'and',
            }}
          />
        ) : (
          <CheckboxPanel
            {...{
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'checkboxId' implicitly has an 'any' type.
              setter: (checkboxId, value) =>
                setCheckboxStateForFilter(checkboxId, value, {
                  add: addSafetyFeature,
                  remove: removeSafetyFeature,
                  update: updateSafetyFeatures,
                }),
              checkboxes: buildCheckboxObjects(
                'SAFETY_FEATURES',
                sortCheckboxConfigAlphabetically(checkboxConfig.SAFETY_FEATURES)
              ),
              attribute: algoliaAttributes.SAFETY_FEATURES,
              defaultRefinement: selectedSafetyFeatures,
              operator: 'and',
            }}
          />
        ),
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'id' implicitly has an 'any' type.
      onRemove: (id) => removeSafetyFeature(id),
    },
    POWER_TYPE: {
      id: 'POWER_TYPE',
      name: 'Power type',
      content: (isMounted = true) =>
        !isMounted ? (
          <VirtualRefinementList
            {...{
              attribute: algoliaAttributes.POWER_TYPE,
              defaultRefinement: buildPowerTypeFilter(selectedPowerTypes),
              operator: 'or',
            }}
          />
        ) : (
          <CheckboxPanel
            {...{
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'field' implicitly has an 'any' type.
              setter: (field, value) =>
                setCheckboxStateForFilter(field, value, {
                  add: addPowerType,
                  remove: removePowerType,
                  update: updatePowerTypes,
                }),
              checkboxes: buildCheckboxObjects('POWER_TYPE', checkboxConfig.POWER_TYPE),
              attribute: algoliaAttributes.POWER_TYPE,
              currentRefinement: selectedPowerTypes || [],
              defaultRefinement: buildPowerTypeFilter(selectedPowerTypes),
              // Provides the checkbox the constituent power types of the aggregated power type
              // This is used to check the checkbox when the aggregated power type is selected
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ Hybrid: string[]; Electric: string[]; }'.
              getExpandedValues: (id) => POWER_TYPE_MAPPING[id] || [id],
              operator: 'or',
            }}
          />
        ),
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'id' implicitly has an 'any' type.
      onRemove: (id) => removePowerType(id),
    },
    LIFESTYLE: {
      id: 'LIFESTYLE',
      name: 'Lifestyle',
      content: (isMounted = true) =>
        !isMounted ? (
          <VirtualRefinementList
            {...{
              attribute: algoliaAttributes.LIFESTYLE,
              defaultRefinement: selectedLifestyles,
            }}
          />
        ) : (
          <CheckboxPanel
            {...{
              // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'field' implicitly has an 'any' type.
              setter: (field, value) =>
                setCheckboxStateForFilter(field, value, {
                  add: addLifestyle,
                  remove: removeLifestyle,
                  update: updateLifestyles,
                }),
              checkboxes: buildCheckboxObjects('LIFESTYLE', checkboxConfig.LIFESTYLE),
              attribute: algoliaAttributes.LIFESTYLE,
              defaultRefinement: selectedLifestyles,
            }}
          />
        ),
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'id' implicitly has an 'any' type.
      onRemove: (id) => removeLifestyle(id),
    },
  };
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'objects' implicitly has an 'any' type.
const transformIntoCheckboxConfig = (objects, algoliaAttribute = null) => {
  const withNoDuplicates = _.uniqBy(objects, ({ id }) => id);
  const withNoEmpties = _.filter(withNoDuplicates, ({ id }) => !!id);
  const transformed = _.map(withNoEmpties, (item) => {
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: 'item' is of type 'unknown'.
    let label = item.id;

    if (_.get(item, 'label')) {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: 'item' is of type 'unknown'.
      label = item.label;
    } else if (algoliaAttribute === algoliaAttributes.MAKE) {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: 'item' is of type 'unknown'.
      label = _.startCase(item.id);
    }
    return {
      // @ts-expect-error [🤖 PLEASE FIX 🤖]: 'item' is of type 'unknown'.
      id: item.id,
      label,
    };
  });

  return _.concat({ label: 'All', id: ALL_ID }, transformed);
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'selectedTypes' implicitly has an 'any' type.
const buildPowerTypeFilter = (selectedTypes) => {
  if (_.isEmpty(selectedTypes)) return [];

  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ Hybrid: string[]; Electric: string[]; }'.
  const expandedTypes = _.flatMap(selectedTypes, (type) => POWER_TYPE_MAPPING[type] || [type]);

  return expandedTypes;
};

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'makes' implicitly has an 'any' type.
const buildCheckboxConfig = (makes, safetyFeatures) => ({
  // @ts-expect-error [🤖 PLEASE FIX 🤖]: Argument of type 'string' is not assignable to parameter of type 'null | undefined'.
  MAKE: transformIntoCheckboxConfig(makes, algoliaAttributes.MAKE),
  BODY_STYLE: _.map(BODY_STYLES, (bodyStyle, index) => ({
    label: bodyStyle.label,
    id: index,
    imageUrl: bodyStyle.imageUrl,
  })),
  STAR_RATING: transformIntoCheckboxConfig([
    { id: '5 Stars' },
    { id: '4 Stars' },
    { id: '3 Stars' },
    { id: '2 Stars' },
    { id: '1 Stars' },
  ]),
  SAFETY_FEATURES: transformIntoCheckboxConfig(safetyFeatures),
  LIFESTYLE: [
    { label: 'P-plate approved (Victoria only)', id: 'P-Plate Approved' },
    { label: 'Safe Cars for Families', id: 'Safe Cars for Families' },
  ],
  POWER_TYPE: [
    { label: 'Any power type', id: ALL_ID },
    ...Object.keys(POWER_TYPE_MAPPING).map((type) => ({
      label: type,
      id: type,
    })),
  ],
});

export {
  buildFiltersDefaultState,
  buildFilterConfig,
  buildCheckboxConfig,
  buildPowerTypeFilter,
  reduceArrayToCheckboxObject,
  buildCheckboxObjects,
  setCheckboxStateForFilter,
  sortCheckboxConfigAlphabetically,
  algoliaAttributes,
};
